var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBot = function SvgBot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "illus-clr-2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3H9V1c0-.55-.45-1-1-1S7 .45 7 1v2H4C1.79 3 0 4.79 0 7v5c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V7c0-2.21-1.79-4-4-4Zm-8 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Zm8 0c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "illus-clr-2",
    d: "M15 15H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z"
  })));
};
export default SvgBot;